import {getTradeTagsCollectionPath, type TradeTagDb} from '@cp/model';
import {doc, DocumentReference} from 'firebase/firestore';
import {firebaseFirestore} from '../../config/firebase';

export function getTradeTagDocRef(uid: string, tradeTagId: string): DocumentReference<TradeTagDb> {
  return doc(firebaseFirestore, getTradeTagsCollectionPath(uid), tradeTagId) as DocumentReference<TradeTagDb>;
}
